import React, { useState } from "react";
import axios from "axios";
import Loader from "./Loader/Loadding"; // Corrige la ruta si es diferente

function AdjuntoAutoevaluacion({ idSubtitulo, idSolicitud, onUploadSuccess }) {
  const [isLoading, setLoading] = useState(false);
  const [archivos, setArchivos] = useState(null);

  const subirArchivos = (e) => {
    setArchivos(e.target.files);
  };

  const insertarArchivos = async () => {
    if (!archivos || archivos.length === 0) {
      alert("Debe seleccionar al menos un archivo.");
      return;
    }

    setLoading(true);

    const username = "BasicAuth@icontec.org";
    const password = "yQLzqmR7eZSuAmQZUqhY";

    const formData = new FormData();
    for (let i = 0; i < archivos.length; i++) {
      formData.append("files", archivos[i]);
    }

    try {
      const response = await axios.post(
        `https://suadesarrollo.azurewebsites.net/api/CargaAdjuntoAutoEvaluacion?subtitulo=${idSubtitulo}&solicitud=${idSolicitud}`,
        formData,
        {
          auth: {
            username,
            password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("Respuesta:", response.data);
      alert("¡Carga exitosa!");

      // ✅ Si quieres refrescar datos sin recargar toda la página:
      if (onUploadSuccess) {
        onUploadSuccess(response.data);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error al subir archivos:", error);
      alert("Error al cargar los archivos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <hr />
      <div className="m-0 font-weight-bold text-primary">
        Adjunte los documentos de ser necesarios
      </div>
      <br />
      <input
        type="file"
        name="files"
        accept=".png,.jpg,.pdf" // ✅ puedes ampliar formatos si quieres
        multiple
        onChange={subirArchivos}
      />
      <br />
      <button
        className="btn btn-primary"
        onClick={insertarArchivos}
        disabled={isLoading}
      >
        {isLoading ? "Cargando..." : "Insertar archivos"}
      </button>
      {isLoading && <Loader />}
    </div>
  );
}

export default AdjuntoAutoevaluacion;
